import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/utils/isFeatureFlagEnabled';

export const isCampaignGroupEnabled = ({ accountConfig }) =>
    isFeatureFlagEnabled(accountConfig, FEATURE_FLAGS.CAMPAIGN_GROUP_ENABLED);
